import Axios from 'axios'
import EventBus from '@/utils/EventBus'

const aioAPI = Axios.create({
  baseURL: process.env.VUE_APP_AIO_API,
  timeout: 20000
})
const companiesHouseAPIKey = process.env.VUE_APP_COMPANIES_HOUSE_API_KEY
const companiesHouseAPI = Axios.create({
  baseURL: process.env.VUE_APP_COMPANIES_HOUSE_API,
  headers: {'Authorization': `Basic ${btoa(companiesHouseAPIKey + ':')}`},
  timeout: 20000
})
addInterceptors(aioAPI)
addInterceptors(companiesHouseAPI)

function addInterceptors (instance) {
  instance.interceptors.request.use(config => {
    EventBus.$emit('ajax-start')
    return config
  }, error => {
    EventBus.$emit('ajax-stop')
    EventBus.$emit('show-notification', 'danger', 'Couldn\'t connect to server. Please check your connection.')
    return Promise.reject(error)
  })

  instance.interceptors.response.use(response => {
    EventBus.$emit('ajax-stop')
    return response.data
  }, error => {
    if (error.response) {
      EventBus.$emit('show-notification', 'danger', error.response.data)
      EventBus.$emit('ajax-stop')
    } else {
      EventBus.$emit('ajax-stop')
      EventBus.$emit('show-notification', 'danger', 'Couldn\'t connect to server. Please check your connection.')
    }
    return Promise.reject(error)
  })
}

export default {
  checkUserIdForResetPassword (uniqueId) { return aioAPI.get(`registration/checkUserId?u=${uniqueId}`) },

  checkUserIdForUserRegistration (uniqueId) { return aioAPI.get(`registration/checkUserId/${uniqueId}`) },

  createCompanyRegistration (registration) { return aioAPI.post(`registration/company`, registration) },

  getCompanyOfficers (companyNumber) { return companiesHouseAPI.get(`company/${companyNumber}/officers`) },

  getCompanyPSCs (companyNumber) { return companiesHouseAPI.get(`company/${companyNumber}/persons-with-significant-control`) },

  getCompanyRegistration (regToken) { return aioAPI.get(`registration/company/${regToken}`) },

  postEnquiry (enquiry) { return aioAPI.post('registration/enquiry', enquiry) },

  postInitResetPassword (email) { return aioAPI.post('registration/initResetPassword', {email: email}) },

  postResetPassword (newPassword, uniqueId) { return aioAPI.post('registration/resetPassword', {newPassword: newPassword, uniqueId: uniqueId}) },

  postUserRegistration (user) { return aioAPI.post('registration/user', user) },

  searchCompanies (term) { return companiesHouseAPI.get(`search/companies?q=${term}`) },

  updateCompanyRegistration (registration, regToken) { return aioAPI.put(`registration/company/${regToken}`, registration)}
}